import { useSearchParams } from 'react-router-dom';
import { Form, Input, Row, Col, Select, Button } from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';

import { useEditModal } from './carCatalogsEditModal';
import CarTypes from './carTypes';
import { useCarMentenanceContext } from './carMaintenanceProvider';

const { Option } = Select;

const initialValues = {
  car_type: '',
  name: '',
  is_cancel: 2,
};

export default function SearchBar() {
  const [, setSearchParams] = useSearchParams();
  const { showModal: showEditModal } = useEditModal();
  const { carTypes } = useCarMentenanceContext();

  const fields = [
    {
      label: '車型',
      name: 'car_type',
      type: 'select',
      options: [
        { label: '全部', value: '' },
        ...carTypes.map((carType) => ({
          label: `${carType.name} - ${carType.description}`,
          value: carType.name,
        })),
      ],
    },
    {
      label: '車款名稱',
      name: 'name',
      type: 'input',
    },
    {
      label: '啟用狀態',
      name: 'is_cancel',
      type: 'select',
      options: [
        { label: '全部', value: 2 },
        { label: '啟用中', value: 0 },
        { label: '非啟用', value: 1 },
      ],
    },
  ];

  return (
    <Form
      name="carSearchForm"
      initialValues={initialValues}
      onFinish={setSearchParams}>
      <Row gutter={16}>
        {fields.map((field) => (
          <Col
            key={field.name}
            span={8}
            style={{ maxWidth: 300, minWidth: 200 }}>
            <Form.Item label={field.label} name={field.name}>
              {field.type === 'input' ? (
                <Input allowClear />
              ) : (
                <Select>
                  {field.options.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
        ))}
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={12} md={8}>
          <CarTypes />
        </Col>
        <Col xs={24} sm={12} md={8} className="button-group">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => showEditModal(null)}
            className="button button--register">
            新增
          </Button>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            htmlType="submit"
            className="button button--search">
            搜尋
          </Button>
        </Col>
      </Row>
    </Form>
  );
}
